(function () {
  const root = document.querySelector('[data-sg-shop]');
  if (!root) return;

  const countEl = root.querySelector('[data-sg-cart-count]');
  const bodyEl = root.querySelector('[data-sg-cart-body]');
  const footEl = root.querySelector('[data-sg-cart-foot]');
  const totalEl = root.querySelector('[data-sg-cart-total]');
  const drawer = root.querySelector('[data-sg-cart-drawer]');

  const formatMoney = function (cents) {
    return '€' + (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
  };

  const openCart = function () {
    root.classList.add('sg-cart-open');
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
  };

  const closeCart = function () {
    root.classList.remove('sg-cart-open');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  };

  const escapeHtml = function (value) {
    return String(value || '').replace(/[&<>'"]/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char];
    });
  };

  const renderCart = function (cart) {
    if (countEl) countEl.textContent = cart.item_count || 0;
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price || 0);

    if (!bodyEl || !footEl) return;

    if (!cart.items || cart.items.length === 0) {
      bodyEl.innerHTML = '<div class="sg-cart-empty"><p>Dein Warenkorb ist leer.</p><button class="sg-button ghost sm" type="button" data-sg-close-cart>Weiter einkaufen</button></div>';
      footEl.classList.remove('has-items');
      return;
    }

    footEl.classList.add('has-items');
    bodyEl.innerHTML = cart.items.map(function (item, index) {
      const img = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="">' : '';
      return '<div class="sg-cart-line">' +
        '<div class="sg-cart-thumb">' + img + '</div>' +
        '<div>' +
          '<div class="sg-cart-line-title">' + escapeHtml(item.product_title) + '</div>' +
          '<div class="sg-cart-line-sub">' + escapeHtml(item.variant_title || '') + '</div>' +
          '<div class="sg-qty">' +
            '<button type="button" data-sg-change-line="' + (index + 1) + '" data-sg-qty="' + Math.max(0, item.quantity - 1) + '">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-sg-change-line="' + (index + 1) + '" data-sg-qty="' + (item.quantity + 1) + '">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="sg-cart-line-price">' +
          '<strong>' + formatMoney(item.final_line_price) + '</strong><br>' +
          '<button type="button" data-sg-change-line="' + (index + 1) + '" data-sg-qty="0">entfernen</button>' +
        '</div>' +
      '</div>';
    }).join('');
  };

  const fetchCart = function () {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  };

  const addVariant = function (variantId) {
    if (!variantId) return;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return fetchCart();
      })
      .then(openCart)
      .catch(function () { window.location.href = '/cart'; });
  };

  const changeLine = function (line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    })
      .then(function (res) { return res.json(); })
      .then(renderCart);
  };

  document.addEventListener('click', function (event) {
    const add = event.target.closest('[data-sg-add]');
    if (add) {
      event.preventDefault();
      addVariant(add.getAttribute('data-variant-id'));
      return;
    }

    if (event.target.closest('[data-sg-open-cart]')) {
      event.preventDefault();
      fetchCart().then(openCart);
      return;
    }

    if (event.target.closest('[data-sg-close-cart]')) {
      event.preventDefault();
      closeCart();
      return;
    }

    const change = event.target.closest('[data-sg-change-line]');
    if (change) {
      event.preventDefault();
      changeLine(change.getAttribute('data-sg-change-line'), change.getAttribute('data-sg-qty'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCart();
  });

  fetchCart();
})();

(function () {
  const mainImage = document.querySelector('[data-sg-product-main-image]');
  if (!mainImage) return;

  document.addEventListener('click', function (event) {
    const thumb = event.target.closest('[data-sg-product-thumb]');
    if (!thumb) return;

    event.preventDefault();
    const full = thumb.getAttribute('data-full');
    const srcset = thumb.getAttribute('data-srcset');
    const alt = thumb.getAttribute('data-alt') || '';

    if (full) mainImage.setAttribute('src', full);
    if (srcset) mainImage.setAttribute('srcset', srcset);
    mainImage.setAttribute('alt', alt);

    document.querySelectorAll('[data-sg-product-thumb]').forEach(function (button) {
      button.classList.toggle('is-active', button === thumb);
    });
  });
})();
